(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('RptCompendiumMessageSearch', RptCompendiumMessageSearch);

    RptCompendiumMessageSearch.$inject = ['$resource'];

    function RptCompendiumMessageSearch($resource) {
        var resourceUrl =  'api/_search/rpt-compendium-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
